import type { ThankYouCard } from '@dmp/qqms/types';

export const defaultThankYouCard: ThankYouCard = {
    id: '',
    type: 'thankYouCard',
    body: 'Thank you for your response.',
    traxexLabel: 'ThankYouCard',
};
